export const mapStateToProps = (state: any, ownProps: any) => ({
  ...state,
  ...ownProps
});



// WEBPACK FOOTER //
// ./src/utils/mapper.ts